export const request = {
  mode: "zh",
  request: {
    title: "SEL-DI服务申请咨询",
    company: "公司名称",
    companyPlaceholder: "请输入公司名称",
    name: "姓名",
    namePlaceholder: "请输入姓名",
    phoneNumber: "电话号码",
    email: "邮箱",
    site: "网页",
    agreeTitle: "同意收集信息",
    required: "必选",
    requiredDescription: "同意个人信息收集及使用",
    notRequired: "选择",
    notRequiredDescription: "同意接收介绍书，公司新闻等SEL-DI相关信息",
    button: "申请SEL-DI",
  },
};
